<template style="background-color: white;">
    <div style="background-color: white; line-height: 1.7em;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row dense>
            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"><v-icon
                    left>mdi-printer</v-icon> Print <v-icon right></v-icon></v-btn>
            <v-btn class="button no-display" @click="dialog_marks = true">Give Remark For Terminal</v-btn>
            <v-btn class="button no-display" @click="dialog_marks_sem2 = true">Give Remark For Annual</v-btn>
        </v-row>
        <div class="d-flex">
            <div style="border: 15px solid transparent; flex: 100%; background-color: transparent;">
                <div style="flex: 100%; background-color: #e8daef; width: 97.56vw;">
                    <div class="d-flex" style="height: 798px;">
                        <div
                            style="border-right: 15px solid #9b59b6 !important; border: 15px solid #9b59b6; background-color: #e8daef; flex: 50%; justify-content: center;">
                            <v-row v-if="org_id == 'sanjivani'" justify="center">
                                <h4>{{ org_basic_data.trust_name }}</h4>
                            </v-row>
                            <v-row v-if="org_id == 'sanjivani'" justify="center" style="margin-bottom:-15px;">
                                <h1>{{ org_basic_data.school_name }}</h1>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12" sm="2" md="2"></v-col>
                                <v-col cols="12" sm="2" md="2" class="ml-6">

                                    <img :src="org_basic_data.school_logo" width="80px" height="80px" alt="logo" />

                                </v-col>
                                <v-col cols="12" sm="3" md="3"> <span
                                        style="text-transform: uppercase; font-size: 50px; font-weight: bolder; color: #450676; font-family: 'Times New Roman', Times, serif;">Zeal</span><br />
                                    <span
                                        style="text-transform: uppercase; font-size: 23px; font-weight: bolder; color: #450676; font-family: 'Times New Roman', Times, serif;">Institutes</span></v-col>
                                <v-col cols="12" sm="3" md="3"> <img :src="org_basic_data.trust_logo" width="80px"
                                        height="80px" alt="logo" /></v-col>
                            </v-row>
                            <div class="col-12">
                                    <center>
                                        <span
                                            style="font-size: 12px; white-space: nowrap; font-weight: bolder; color: black;"><span
                                                class="mdi mdi-map-marker"></span>{{ org_basic_data.address }}</span>
                                    </center>
                                </div>
                            <div class="row" v-if="org_id == 'sanjivani'">
                                <div class="col-12" style="margin-top: -12px;">
                                    <center>
                                        <img :src="org_basic_data.school_logo" width="80px" height="80px" alt="logo" />
                                    </center>
                                </div>
                            </div>


                            <div class="row" style="margin-top: -60px;" v-else>
                                <div class="col-12">
                                    <center>
                                        <span style="font-size: x-small; font-weight: bolder; color: black;">
                                            {{ org_basic_data.website }}</span>
                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -40px;" v-if="org_id == 'zeal'">
                                <div class="col-12">
                                    <center>
                                        <span
                                            style="text-transform: uppercase; font-size: x-small; font-weight: bolder; color: black;">
                                            Narhe | Pune | India</span>
                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -40px;" v-if="org_id == 'zeal'">
                                <div class="col-12">
                                    <center>
                                        <span
                                            style="text-transform: uppercase; font-size: x-small; white-space: nowrap; font-weight: bolder; color: black;">schools
                                            | jr.college | iti | Polytechnic | Enineering | MBA | Mca | ph D</span>
                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -10px;" v-if="org_id == 'zeal'">
                                <div class="col-12">
                                    <center>
                                        <span class="school-name"
                                            style="text-transform: uppercase; font-size: medium; font-weight: bolder; color: white;">
                                            {{ org_basic_data.school_name }}</span>
                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -20px;" v-if="org_id == 'zeal'">
                                <div class="col-12">
                                    <center>
                                        <span
                                            style="font-size: x-small; white-space: nowrap; font-weight: bolder; color: black;"><span
                                                class="mdi mdi-map-marker"></span>{{ org_basic_data.address }}</span>
                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -40px;" v-if="org_id == 'zeal'">
                                <div class="col-12">
                                    <center>
                                        <span
                                            style="font-size: x-small; white-space: nowrap; font-weight: bolder; color: black;">
                                            <span class="mdi mdi-cellphone"></span>{{ org_basic_data.phone }} <span
                                                class="mdi mdi-email"></span>{{ org_basic_data.email }}<span
                                                class="mdi mdi-web"></span>{{ org_basic_data.website }}
                                        </span>
                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -20px;">
                                <div class="col-12">
                                    <center>
                                        <span class="round" v-if="org_id == 'sanjivani'"
                                            style="text-transform: uppercase; font-size: medium; font-weight: bolder; ">
                                            Progress Card
                                        </span>
                                        <span class="ribbon" v-else
                                            style="text-transform: uppercase; font-size: medium; font-weight: bolder; color: white;">
                                            Achievement Record
                                        </span>

                                    </center>
                                </div>
                            </div>
                            <div class="row" style="margin-top: -10px; margin-bottom: -15px;">
                                <div class="col-12">
                                    <center>
                                        <span
                                            style="text-transform: uppercase; font-size: x-large; white-space: nowrap; color: #005ab3;">{{
                                                ay }}</span>
                                    </center>
                                </div>
                            </div>

                            <v-simple-table v-if="org_id === 'sanjivani'" class="styled-div2">
                                <template>
                                    <tbody>
                                        <tr>
                                            <td colspan="3"><strong>Name Of the Student :</strong> {{ name }}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Roll Number :</strong> {{ roll_no }}</td>

                                        </tr>
                                        <tr>
                                            <td><strong>Std. :</strong>{{ standard }} </td>
                                            <td><strong>G. Reg. No. :</strong> {{ reg_no }}</td>

                                        </tr>


                                        <tr>
                                            <td><strong>Father's Name :</strong>{{ father_full_name }}</td>
                                            <td><strong>Occupation :</strong>{{ father_occupation }}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Mother's Name :</strong> {{ mother_name }}</td>
                                            <td><strong>Occupation :</strong> {{ mother_occupation }}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Date of Birth :</strong> {{ dob }}</td>
                                            <td><strong>Age :</strong> {{ age }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"><strong>Address :</strong> {{ address }}</td>
                                        </tr>
                                        <tr>
                                            <!-- <td colspan="2"><strong>Tel.No.Resi :</strong> {{ telephone_no }}</td> -->
                                            <!-- <td><strong>Ph.No :</strong> {{ telephone_no }}</td> -->
                                             <td><strong>Ph.No :</strong> {{ father_contact_number }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="4"
                                                style="text-align: center; font-weight: bolder; text-transform: uppercase; background-color: white;">
                                                <h2>Health Information</h2>
                                            </td>
                                        </tr>
                                        <!-- <tr>
                                            <td><strong>Weight :</strong> {{ user_bmi_list_sem2.height }}</td>
                                            <td><strong>Height :</strong> {{ user_bmi_list_sem2.weight }}</td>

                                        </tr> -->
<tr>
                                            <td>
                                                <strong>Weight :</strong>
                                                {{ (user_bmi_list_sem2.weight && user_bmi_list_sem2.height)
                                                ? user_bmi_list_sem2.weight
                                                : (user_bmi_list_sem1.weight && user_bmi_list_sem1.height)
                                                ? user_bmi_list_sem1.weight
                                                : '' }}
                                            </td>
                                        
                                            <td>
                                                <strong>Height :</strong>
                                                {{ (user_bmi_list_sem2.weight && user_bmi_list_sem2.height)
                                                ? user_bmi_list_sem2.height
                                                : (user_bmi_list_sem1.weight && user_bmi_list_sem1.height)
                                                ? user_bmi_list_sem1.height
                                                : '' }}
                                            </td>
                                        </tr>


                                    </tbody>
                                </template>
                            </v-simple-table>
                            <v-simple-table v-else class="styled-div">
                                <template >
                                    <tbody>
                                        <tr>
                                            <td colspan="3"><strong>Name Of the Student :</strong> {{ name }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"><strong>Date of Birth :</strong> {{ dob }}</td>
                                            <td><strong>Age :</strong> {{ age }}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Reg No :</strong> {{ reg_no }}</td>
                                            <td><strong>Roll Number :</strong> {{ roll_no }}</td>
                                            <td><strong>House :</strong> {{ house }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"><strong>Father's Name :</strong> {{ father_full_name }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"><strong>Mother's Name :</strong> {{ mother_name }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"><strong>Address :</strong> {{ address }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"><strong>Tel.No.Resi :</strong> {{ telephone_no }}</td>
                                            <td><strong>Office :</strong> {{ mobile_no }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"><strong>E-mail :</strong> {{ email }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"><strong>Aadhaar Card No :</strong> {{ adhar_no }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            
                        </div>
                        <div
                            style="border-left: 15px solid #9b59b6 !important; border: 15px solid #9b59b6; background-color: #e8daef; flex: 50%;">
                            <div class="row">
                                <div class="col-12" style="text-align: center;">
                                    <span style="text-transform: uppercase; font-size: large; color: #9b59b6;"
                                        v-if="org_id == 'zeal'">
                                        Attendance
                                    </span>
                                    <span v-else style="text-transform: uppercase; font-size: large; color: #9b59b6;">
                                        Students' Attendance
                                    </span>
                                </div>
                            </div>

                            <v-simple-table id="table1" dense class="elevation-1" fixed-header
                                style="margin: 0px 25px;">
                                <thead style="text-align: center;">
                                    <tr>
                                        <th style="text-transform: uppercase; width: 30%;">Month</th>
                                        <th style="text-transform: uppercase; width: 25%;">first term</th>
                                        <th style="text-transform: uppercase;">Second term</th>
                                        <th style="text-transform: uppercase;">total</th>
                                    </tr>
                                </thead>
                                <tbody style="overflow-y: scroll;">
                                    <tr>
                                        <td>Working Days</td>
                                        <td>{{ sem1_attendance[0].total_working_days_sem }}</td>
                                        <td>{{ sem2_attendance[0].total_working_days_sem }}</td>
                                        <td>{{ sem1_attendance[0].total_working_days_sem +
                                            sem2_attendance[0].total_working_days_sem }}</td>
                                    </tr>
                                    <tr>
                                        <td>Present Days</td>
                                        <td>{{ sem1_attendance[0].present }}</td>
                                        <td>{{ sem2_attendance[0].present }}</td>
                                        <td>{{ sem1_attendance[0].present + sem2_attendance[0].present }}</td>
                                    </tr>
                                    <tr>
                                        <td>Class Teacher's Sign</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Parent's Sign</td>
                                        <td></td>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td>Principal's Sign</td>
                                        <td></td>
                                        <td colspan="2"></td>
                                    </tr>

                                    <tr v-if="org_id !== 'sanjivani'">
                                        <td colspan="4"
                                            style="text-align: center; font-weight: bolder; text-transform: uppercase;">
                                            Physical Growth
                                        </td>
                                    </tr>
                                    <tr v-if="org_id !== 'sanjivani'">
                                        <td colspan="2">Height</td>
                                        <td colspan="2">{{ user_bmi_list_sem2.height }}</td>
                                    </tr>
                                    <tr v-if="org_id !== 'sanjivani'">
                                        <td colspan="2">Weight</td>
                                        <td colspan="2">{{ user_bmi_list_sem2.weight }}</td>
                                    </tr>



                                </tbody>
                            </v-simple-table>

                            <div class="col-12" style="text-align: center;">
                                <span style="text-transform: uppercase; font-size: large; color: black;"
                                    v-if="org_id == 'zeal'">
                                    Interpretation
                                </span>
                                <span style="text-transform: uppercase; font-size: large; color: black;" v-else>
                                    Grade Chart
                                </span>
                            </div>
                            <v-simple-table dense class="elevation-1" fixed-header id="table1"
                                style="max-width: 400px; margin-left: 100px;">
                                <thead>
                                    <tr>
                                        <th style="text-transform: uppercase; text-align: center;">Marks</th>
                                        <th style="text-transform: uppercase; text-align: center;">Grade</th>
                                    </tr>
                                </thead>
                                <tbody style="overflow-y: scroll;">
                                    <tr v-for="(s, index) in leraner_marksheet.grade_details" :key="index">
                                        <td style="text-align: center;">{{ s.range }}</td>
                                        <td style="text-align: center;">{{ s.gradename }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <br />
                            <div style="margin-left:40px;position:absolute;top: 45%;" v-if="org_id == 'zeal'">
                                <v-row>
                                    <span style="font-size: small; font-weight: bolder; color: black;">Passed & Promoted
                                        to </span>
                                    <span
                                        style="border-bottom: 1px solid black; display: inline-block; width: 140px;"></span>
                                    <span style="font-size: small; font-weight: bolder; color: black;">The School
                                        reopnes on </span>
                                    <span
                                        style="border-bottom: 1px solid black; display: inline-block; width: 90px;"></span>
                                </v-row>
                                <v-row>
                                    <span style="font-size: small; font-weight: bolder; color: black;">and will function
                                        from </span>
                                    <span
                                        style="border-bottom: 1px solid black; display: inline-block; width: 200px;"></span>
                                    <span style="font-size: small; font-weight: bolder; color: black;">to</span>
                                    <span
                                        style="border-bottom: 1px solid black; display: inline-block; width: 100px;"></span>
                                </v-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ---- -->
        <div class="pagebreak d-flex">
            <div style="border: 15px solid transparent; flex: 100%; background-color: transparent; height: 100%;">
                <div style="flex: 100%; background-color: #e8daef; width: 97.56vw;">
                    <div class="d-flex" style="height: 790px;">
                        <div
                            style="border-right: 15px solid #9b59b6 !important; border: 15px solid #9b59b6; background-color: #bfcfff; flex: 50%; justify-content: center;">
                            <div class="row">
                                <div class="col-12" style="text-align: center;margin-top: 20px;">
                                    <span style="text-transform: uppercase; font-size: x-large; color: black;"
                                        v-if="org_id == 'zeal'">
                                        Terminal Examination
                                    </span>
                                    <span style="text-transform: uppercase; font-size: x-large; color: black;" v-else>
                                        First Semester
                                    </span>
                                </div>
                            </div>
                            <br />
                            <v-simple-table id="table_term" dense class="elevation-1" fixed-header
                                style="margin: 0px 25px">
                                <thead>
                                    <tr>
                                        <th class="">Sr. No.</th>
                                        <th class="">Subject</th>
                                        <th class="">Grade</th>
                                        <th v-if="org_id == 'zeal'" class="">Descriptive Remarks</th>
                                        <th v-else class="">Descriptive Information</th>
                                    </tr>
                                </thead>
                                <tbody style="overflow-y: scroll; height: 500px;">
                                    <tr v-for="(s, index) in leraner_marksheet.leraner_marksheet" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ s.crs_name }}</td>
                                        <td>{{ s.overall_grade }}</td>
                                        <!-- <td class="text-left" style="width: 50%;" v-if="index == 0"
                                            v-bind:rowspan="leraner_marksheet.leraner_marksheet.length">
                                            <span v-if="org_id == 'zeal'"
                                                style="position: absolute; margin-top: -10%;"><strong>Special
                                                    Achievement</strong> </span>
                                            <span v-else
                                                style="position: absolute; margin-top: -10%;"><strong>Remarkable
                                                    Progress</strong> </span>
                                            <br />
                                            <span style="position: absolute; margin-top: -10%; width: 40%;">{{
                                                leraner_marksheet.special_achievement }}</span> <br />
                                            <span v-if="org_id == 'zeal'"
                                                style="position: absolute; margin-top: -6%;"><strong>Extra Curricular
                                                    Activities</strong></span>
                                            <span v-else
                                                style="position: absolute; margin-top: -6%;"><strong>Hobbies</strong></span>
                                            <br />
                                            <span style="position: absolute; margin-top: -6%; width: 40%;">{{
                                                leraner_marksheet.extra_caricular }}</span> <br />
                                            <span v-if="org_id == 'zeal'"
                                                style="position: absolute; margin-top: 3%;"><strong>General
                                                    Remarks</strong> </span>
                                            <span v-else style="position: absolute; margin-top: 3%;"><strong> Expected
                                                    Improvement</strong> </span>
                                            <br />
                                            <span style="position: absolute; margin-top: 3%; width: 40%;">{{
                                                leraner_marksheet.remark }}</span> <br />
                                        </td> -->
                                        <!-- TERMINAL (First Semester) Remarks Column -->
<td class="text-left" style="width: 50%; position: relative; padding: 20px 10px;" 
    v-if="index == 0" 
    :rowspan="leraner_marksheet.leraner_marksheet.length">

  <!-- Special Achievement / Remarkable Progress -->
  <div style="position: absolute; top: 8%; width: 95%;">
    <strong v-if="org_id == 'zeal'">Special Achievement</strong>
    <strong v-else>Remarkable Progress</strong>
    <div style="margin-top: 8px; line-height: 1.6; font-size: 13.5px;">
      <template v-if="leraner_marksheet.special_achievement">
        <div v-if="leraner_marksheet.special_achievement.split('<br>').length > 1">
          <div v-for="(line, i) in leraner_marksheet.special_achievement.split('<br>')" :key="i"
               v-if="line.trim()" 
               style="display: flex; align-items: flex-start; margin-bottom: 4px;">
            <span style="margin-right: 12px; color: #1a1a1a; font-size: 20px; font-weight: bold; line-height: 1;">•</span>
            <span v-html="line"></span>
          </div>
        </div>
        <div v-else v-html="leraner_marksheet.special_achievement"></div>
      </template>
    </div>
  </div>

  <!-- Extra Curricular / Hobbies -->
  <div style="position: absolute; top: 38%; width: 95%;">
    <strong v-if="org_id == 'zeal'">Extra Curricular Activities</strong>
    <strong v-else>Hobbies</strong>
    <div style="margin-top: 8px; line-height: 1.6; font-size: 13.5px;">
      <template v-if="leraner_marksheet.extra_caricular || leraner_marksheet.extra_carricular_activities">
        <div v-if="(leraner_marksheet.extra_caricular || leraner_marksheet.extra_carricular_activities).split('<br>').length > 1">
          <div v-for="(line, i) in (leraner_marksheet.extra_caricular || leraner_marksheet.extra_carricular_activities).split('<br>')" :key="i"
               v-if="line.trim()" 
               style="display: flex; align-items: flex-start; margin-bottom: 4px;">
                 <span style="margin-right: 12px; color: #1a1a1a; font-size: 20px; font-weight: bold; line-height: 1;">•</span>
            <span v-html="line"></span>
          </div>
        </div>
        <div v-else v-html="leraner_marksheet.extra_caricular || leraner_marksheet.extra_carricular_activities"></div>
      </template>
    </div>
  </div>

  <!-- General Remarks / Expected Improvement -->
  <div style="position: absolute; top: 68%; width: 95%;">
    <strong v-if="org_id == 'zeal'">General Remarks</strong>
    <strong v-else>Expected Improvement</strong>
    <div style="margin-top: 8px; line-height: 1.6; font-size: 13.5px;">
      <template v-if="leraner_marksheet.remark">
        <div v-if="leraner_marksheet.remark.split('<br>').length > 1">
          <div v-for="(line, i) in leraner_marksheet.remark.split('<br>')" :key="i"
               v-if="line.trim()" 
               style="display: flex; align-items: flex-start; margin-bottom: 4px;">
                        <span style="margin-right: 12px; color: #1a1a1a; font-size: 20px; font-weight: bold; line-height: 1;">•</span>
            <span v-html="line"></span>
          </div>
        </div>
        <div v-else v-html="leraner_marksheet.remark"></div>
      </template>
    </div>
  </div>
</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <br />
                            <div v-if="org_id === 'sanjivani'">

                                <div class="row"
                                    style='position: absolute;bottom: 1%;width: 50%;font-weight: bolder;margin-left: 3%;'>
                                    <v-col cols="3"> Class Teacher</v-col>
                                    <v-col cols="3"> Exam I/c. </v-col>
                                    <v-col cols="3">
                                        <span>Principal</span>
                                    </v-col>
                                    <v-col cols="3">
                                        <span>Parent</span>
                                    </v-col>
                                </div>
                            </div>
                            <div class="row" v-else
                                style='position: absolute;bottom: 3%;width: 50%;font-weight: bolder;margin-left: 3%;'>
                                <v-col cols="4"> Class Teacher's Sign </v-col>
                                <v-col cols="4">
                                    <span>Principal's Sign</span>
                                </v-col>
                                <v-col cols="4">
                                    <span>Parent's Sign</span>
                                </v-col>
                            </div>
                        </div>
                        <div
                            style="border-right: 15px solid #9b59b6 !important; border: 15px solid #9b59b6; background-color: #bfcfff; flex: 50%; justify-content: center;">
                            <div class="row">
                                <div class="col-12" style="text-align: center;margin-top: 20px;">
                                    <span style="text-transform: uppercase; font-size: x-large; color: black;"
                                        v-if="org_id == 'zeal'">
                                        Annual Examination
                                    </span>
                                    <span style="text-transform: uppercase; font-size: x-large; color: black;" v-else>
                                        Second Semester
                                    </span>
                                </div>
                            </div>
                            <br />
                            <v-simple-table id="table_term" dense class="elevation-1" fixed-header
                                style="margin: 0px 25px">
                                <thead>
                                    <tr>
                                        <th class="">Sr. No.</th>
                                        <th class="">Subject</th>
                                        <th class="">Grade</th>
                                        <th v-if="org_id == 'zeal'" class="">Descriptive Remarks</th>
                                        <th v-else class="">Descriptive Information</th>
                                    </tr>
                                </thead>
                                <tbody style="overflow-y: scroll; height: 500px;">
                                    <tr v-for="(s, index) in leraner_marksheet.leraner_marksheet_sem2" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ s.crs_name }}</td>
                                        <td>{{ s.overall_grade }}</td>
                                        <!-- <td class="text-left" style="width: 50%;" v-if="index == 0"
                                            v-bind:rowspan="leraner_marksheet.leraner_marksheet_sem2.length">
                                            <span v-if="org_id == 'zeal'"
                                                style="position: absolute; margin-top: -10%;"><strong>Special
                                                    Achievement</strong> </span>
                                            <span v-else
                                                style="position: absolute; margin-top: -10%;"><strong>Remarkable
                                                    Progress</strong> </span>
                                            <br />
                                            <span style="position: absolute; margin-top: -10%; width: 40%;">{{
                                                leraner_marksheet.special_achievement_sem2 }}</span><br />
                                            <span style="position: absolute; margin-top: -6%;"
                                                v-if="org_id == 'zeal'"><strong>Extra Curricular
                                                    Activities</strong> </span>
                                            <span v-else
                                                style="position: absolute; margin-top: -6%;"><strong>Hobbies</strong></span>
                                            <br />
                                            <span style="position: absolute; margin-top: -6%; width: 40%;">{{
                                                leraner_marksheet.extra_caricular_sem2 }} </span><br />
                                            <span v-if="org_id == 'zeal'"
                                                style="position: absolute; margin-top: 3%;"><strong>General
                                                    Remarks</strong> </span>
                                            <span v-else style="position: absolute; margin-top: 3%;"><strong> Expected
                                                    Improvement</strong> </span>
                                            <br />
                                            <span style="position: absolute; margin-top: 3%; width: 40%;">{{
                                                leraner_marksheet.remark_sem2 }} </span><br />
                                        </td> -->
<td class="text-left" style="width: 50%; position: relative; padding: 20px 10px;" 
    v-if="index == 0" 
    :rowspan="leraner_marksheet.leraner_marksheet_sem2.length">

  <!-- Special Achievement -->
  <div style="position: absolute; top: 8%; width: 95%;">
    <strong v-if="org_id == 'zeal'">Special Achievement</strong>
    <strong v-else>Remarkable Progress</strong>
    <div style="margin-top: 8px; line-height: 1.6; font-size: 13.5px;">
      <template v-if="leraner_marksheet.special_achievement_sem2">
        <div v-if="leraner_marksheet.special_achievement_sem2.split('<br>').length > 1">
          <div v-for="(line, i) in leraner_marksheet.special_achievement_sem2.split('<br>')" :key="i"
               v-if="line.trim()" 
               style="display: flex; align-items: flex-start; margin-bottom: 4px;">
            <span style="margin-right: 12px; color: #1a1a1a; font-size: 20px; font-weight: bold; line-height: 1;">•</span>
            <span v-html="line"></span>
          </div>
        </div>
        <div v-else v-html="leraner_marksheet.special_achievement_sem2"></div>
      </template>
    </div>
  </div>

  <!-- Extra Curricular -->
  <div style="position: absolute; top: 38%; width: 95%;">
    <strong v-if="org_id == 'zeal'">Extra Curricular Activities</strong>
    <strong v-else>Hobbies</strong>
    <div style="margin-top: 8px; line-height: 1.6; font-size: 13.5px;">
      <template v-if="leraner_marksheet.extra_caricular_sem2 || leraner_marksheet.extra_carricular_activities_sem2">
        <div v-if="(leraner_marksheet.extra_caricular_sem2 || leraner_marksheet.extra_carricular_activities_sem2).split('<br>').length > 1">
          <div v-for="(line, i) in (leraner_marksheet.extra_caricular_sem2 || leraner_marksheet.extra_carricular_activities_sem2).split('<br>')" :key="i"
               v-if="line.trim()" 
               style="display: flex; align-items: flex-start; margin-bottom: 4px;">
                        <span style="margin-right: 12px; color: #1a1a1a; font-size: 20px; font-weight: bold; line-height: 1;">•</span>
            <span v-html="line"></span>
          </div>
        </div>
        <div v-else v-html="leraner_marksheet.extra_caricular_sem2 || leraner_marksheet.extra_carricular_activities_sem2"></div>
      </template>
    </div>
  </div>

  <!-- General Remarks -->
  <div style="position: absolute; top: 68%; width: 95%;">
    <strong v-if="org_id == 'zeal'">General Remarks</strong>
    <strong v-else>Expected Improvement</strong>
    <div style="margin-top: 8px; line-height: 1.6; font-size: 13.5px;">
      <template v-if="leraner_marksheet.remark_sem2">
        <div v-if="leraner_marksheet.remark_sem2.split('<br>').length > 1">
          <div v-for="(line, i) in leraner_marksheet.remark_sem2.split('<br>')" :key="i"
               v-if="line.trim()" 
               style="display: flex; align-items: flex-start; margin-bottom: 4px;">
                        <span style="margin-right: 12px; color: #1a1a1a; font-size: 20px; font-weight: bold; line-height: 1;">•</span>
            <span v-html="line"></span>
          </div>
        </div>
        <div v-else v-html="leraner_marksheet.remark_sem2"></div>
      </template>
    </div>
  </div>
</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <!-- <br /> -->
                            <div v-if="org_id === 'sanjivani'">
                                <div style="margin-left:40px;position:absolute;">
                                    <v-row>
                                        <span style="font-size: small; font-weight: bolder; color: black;">Result :
                                            Promoted
                                            into </span>
                                        <span
                                            style="border-bottom: 1px solid black; display: inline-block; width: 140px;"></span>
                                        <span style="font-size: small; font-weight: bolder; color: black;">Class </span>
                                    </v-row>
                                    <v-row>
                                        <span style="font-size: small; font-weight: bolder; color: black;">The School
                                            reopens on
                                        </span>
                                        <span
                                            style="border-bottom: 1px solid black; display: inline-block; width: 200px;"></span>
                                        <span style="font-size: small; font-weight: bolder; color: black;">June</span>
                                        <span
                                            style="border-bottom: 1px solid black; display: inline-block; width: 100px;"></span>
                                    </v-row>
                                </div>
                                <div class="row"
                                    style='position: absolute;bottom: 1%;width: 50%;font-weight: bolder; margin-left:3%;'>
                                    <v-col cols="3"> Class Teacher</v-col>
                                    <v-col cols="3"> Exam I/c. </v-col>
                                    <v-col cols="3">
                                        <span>Principal</span>
                                    </v-col>
                                    <v-col cols="3">
                                        <span>Parent</span>
                                    </v-col>
                                </div>
                            </div>

                            <div class="row" v-else
                                style='position: absolute;bottom: 3%;width: 50%;font-weight: bolder;margin-left: 3%;'>
                                <v-col cols="4"> Class Teacher's Sign </v-col>
                                <v-col cols="4">
                                    <span>Principal's Sign</span>
                                </v-col>
                                <v-col cols="4">
                                    <span>Parent's Sign</span>
                                </v-col>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- v-dialog for terminal remark -->
        <!-- <v-dialog v-model="dialog_marks" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Give Remark </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <center>
                        <v-textarea v-model="special_achievement" outlined
                            :label="org_id == 'zeal' ? 'Special Achievement' : 'Remarkable Progress'"></v-textarea>
                        <v-textarea v-model="extra_activity" outlined
                            :label="org_id == 'zeal' ? 'Extra Carricular Activities' : 'Hobbies'"></v-textarea>
                        <v-textarea v-model="remark" outlined
                            :label="org_id == 'zeal' ? 'General Remark' : 'Expected Improvement'"></v-textarea>
                    </center>
                </v-col>
                <v-row justify="center">
                    <v-btn rounded class="button" @click="saveremark">Save</v-btn>
                    <v-btn rounded class="button" @click="dialog_marks = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog> -->
        <v-dialog v-model="dialog_marks" persistent max-width="900px">
            <v-card>
                <v-toolbar flat dense color="primary" dark>
                    <v-toolbar-title>Give Remark For Terminal</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pt-6">
                    <!-- <v-autocomplete v-model="special_achievement" :items="default_value" item-text="value" item-value="value"
                        label="Special Achievement / Remarkable Progress" multiple chips deletable-chips outlined dense
                        clearable></v-autocomplete>
        
                    <v-autocomplete v-model="extra_activity" :items="default_value" item-text="value" item-value="value"
                        label="Extra Curricular Activities / Hobbies" multiple chips deletable-chips outlined dense
                        clearable></v-autocomplete>
        
                    <v-autocomplete v-model="remark" :items="default_value" item-text="value" item-value="value"
                        label="General Remark / Expected Improvement" multiple chips deletable-chips outlined dense
                        clearable></v-autocomplete> -->
                        <v-autocomplete v-model="special_achievement" :items="remarkable_progress_defaults" item-text="value" item-value="value"
                            label="Special Achievement / Remarkable Progress" multiple chips deletable-chips outlined dense clearable>
                        </v-autocomplete>
                        
                        <v-autocomplete v-model="extra_activity" :items="student_hobbies_defaults" item-text="value" item-value="value"
                            label="Extra Curricular Activities / Hobbies" multiple chips deletable-chips outlined dense clearable>
                        </v-autocomplete>
                        
                        <v-autocomplete v-model="remark" :items="expected_improvement_defaults" item-text="value" item-value="value"
                            label="General Remark / Expected Improvement" multiple chips deletable-chips outlined dense clearable>
                        </v-autocomplete>
                </v-card-text>
                <v-card-actions class="justify-center pb-6">
                    <v-btn color="success" @click="saveremark('term1')" :loading="saving">Save</v-btn>
                    <v-btn @click="dialog_marks = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- v-dialog for anuual remark -->
        <!-- <v-dialog v-model="dialog_marks_sem2" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Give Remark </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <center>
                        <v-textarea v-model="special_achievement_sem2" outlined
                            :label="org_id == 'zeal' ? 'Special Achievement' : 'Remarkable Progress'"></v-textarea>
                        <v-textarea v-model="extra_activity_sem2" outlined
                            :label="org_id == 'zeal' ? 'Extra Carricular Activities' : 'Hobbies'"></v-textarea>
                        <v-textarea v-model="remark_sem2" outlined
                            :label="org_id == 'zeal' ? 'General Remark' : 'Expected Improvement'"></v-textarea>
                    </center>
                </v-col>
                <v-row justify="center">
                    <v-btn rounded class="button" @click="saveremark">Save</v-btn>
                    <v-btn rounded class="button" @click="dialog_marks_sem2 = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog> -->
        <v-dialog v-model="dialog_marks_sem2" persistent max-width="900px">
            <v-card>
                <v-toolbar flat dense color="primary" dark>
                    <v-toolbar-title>Give Remark For Annual </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pt-6">
                    <!-- <v-autocomplete v-model="special_achievement_sem2" :items="default_value" item-text="value"
                        item-value="value" label="Special Achievement / Remarkable Progress" multiple chips deletable-chips
                        outlined dense clearable></v-autocomplete>
        
                    <v-autocomplete v-model="extra_activity_sem2" :items="default_value" item-text="value" item-value="value"
                        label="Extra Curricular Activities / Hobbies" multiple chips deletable-chips outlined dense
                        clearable></v-autocomplete>
        
                    <v-autocomplete v-model="remark_sem2" :items="default_value" item-text="value" item-value="value"
                        label="General Remark / Expected Improvement" multiple chips deletable-chips outlined dense
                        clearable></v-autocomplete> -->
                        <v-autocomplete v-model="special_achievement_sem2" :items="remarkable_progress_defaults" item-text="value"
                            item-value="value" label="Special Achievement / Remarkable Progress" multiple chips deletable-chips outlined dense
                            clearable>
                        </v-autocomplete>
                        
                        <v-autocomplete v-model="extra_activity_sem2" :items="student_hobbies_defaults" item-text="value" item-value="value"
                            label="Extra Curricular Activities / Hobbies" multiple chips deletable-chips outlined dense clearable>
                        </v-autocomplete>
                        
                        <v-autocomplete v-model="remark_sem2" :items="expected_improvement_defaults" item-text="value" item-value="value"
                            label="General Remark / Expected Improvement" multiple chips deletable-chips outlined dense clearable>
                        </v-autocomplete>
                </v-card-text>
                <v-card-actions class="justify-center pb-6">
                    <v-btn color="success" @click="saveremark('term2')" :loading="saving">Save</v-btn>
                    <v-btn @click="dialog_marks_sem2 = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
    props: {
        org: Number,
    },

    data() {
        return {
            text: "",
            direction: 1,
            arc: 150,
            // default_value: [],
            remarkable_progress_defaults: [],
            student_hobbies_defaults: [],
            expected_improvement_defaults: [],
            dialog_marks: false,
            dialog_marks_sem2: false,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            name: null,
            dob: null,
            roll_no: null,
            mobile_no: null,
            telephone_no: null,
            father_contact_number: null,
            address: null,
            mother_name: null,
            photo: null,
            reg_no: null,
            gr_no: null,
            father_full_name: null,
            leraner_marksheet: [],
            sem1_attendance: [],
            sem2_attendance: [],
            semester: null,
            colspan: null,
            overall_grade: null,
            org_basic_data: [],
            mother_contact: null,
            father_contact: null,
            house: null,
            adhar_no: null,
            org_id: null,
            email: null,
            all_data: [],
            age: null,
            sem2: [],
            lms_id: null,
            lms_id_sem2: null,
            remark: null,
            remark_sem2: null,
            special_achievement: null,
            special_achievement_sem2: null,
            extra_activity: null,
            extra_activity_sem2: null,
            total_working_days_sem: null,
            father_occupation: null,
            mother_occupation: null,
            present: null,
            schlname: "",
            headers_1: [
                { text: "Subject", value: "crs_name" },
                { text: "Grade", value: "overall_grade" },
                { text: "Remarks", value: "overall_grade" },
            ],
            headers_2: [
                { text: "Subject", value: "crs_name" },
                { text: "Grade", value: "overall_grade" },
                { text: "Remarks", value: "overall_grade" },
            ],
        };
    },
watch: {
  leraner_marksheet: {
    handler(val) {
      if (!val) return;
      const split = str => str ? str.split('; ').filter(Boolean) : [];

      this.special_achievement      = split(val.special_achievement);
      this.extra_activity           = split(val.extra_caricular || val.extra_carricular_activities);
      this.remark                  = split(val.remark);

      this.special_achievement_sem2 = split(val.special_achievement_sem2);
      this.extra_activity_sem2      = split(val.extra_caricular_sem2 || val.extra_carricular_activities_sem2);
      this.remark_sem2              = split(val.remark_sem2);
    },
    deep: true,
    immediate: true
  }
},
    methods: {
        // saveremark() {
        //     const data = {
        //         lms_id: this.lms_id,
        //         remark: this.remark,
        //         lms_id_sem2: this.lms_id_sem2,
        //         remark: this.remark,
        //         remark_sem2: this.remark_sem2,
        //         special_achievement: this.special_achievement,
        //         special_achievement_sem2: this.special_achievement_sem2,
        //         extra_activity: this.extra_activity,
        //         extra_activity_sem2: this.extra_activity_sem2,
        //     };
        //     axios
        //         .post("/ZealExamination/saveremark", data)
        //         .then((res) => {
        //             if (res.data.flag == "YES") {
        //                 this.showSnackbar("#4caf50", "Remark save successfully...!");
        //                 this.onload();
        //                 this.dialog_marks = false;
        //                 this.dialog_marks_sem2 = false;
        //             }
        //         })
        //         .catch((error) => {
        //             this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        //         })
        //         .finally(() => {
        //             this.remark = null;
        //         });
        // },
        saveremark(term) {
  this.saving = true;

  // Convert arrays → "Item1; Item2; Item3" (exactly what your backend expects)
//   const toString = (arr) => (arr && arr.length > 0) ? arr.join('; ') : null;
const toString = (arr) => (arr && arr.length > 0) ? arr.join('<br>') : null;
  const payload = {
    lms_id: this.lms_id,
    lms_id_sem2: this.lms_id_sem2,
  };

  // Term I fields
  if (term === 'term1') {
    payload.special_achievement = toString(this.special_achievement);
    payload.extra_activity        = toString(this.extra_activity);
    payload.remark               = toString(this.remark);
  }

  // Term II fields
  if (term === 'term2') {
    payload.special_achievement_sem2 = toString(this.special_achievement_sem2);
    payload.extra_activity_sem2        = toString(this.extra_activity_sem2);
    payload.remark_sem2               = toString(this.remark_sem2);
  }

  axios.post("/ZealExamination/saveremark", payload)
    .then(res => {
      if (res.data.flag === "YES") {
        this.showSnackbar("#4caf50", "Remarks saved successfully!");
        this.onload(); // refresh data
        if (term === 'term1') {
          this.special_achievement = [];
          this.extra_activity       = [];
          this.remark              = [];
          this.dialog_marks = false;      
        }

        if (term === 'term2') {
          this.special_achievement_sem2 = [];
          this.extra_activity_sem2       = [];
          this.remark_sem2              = [];
          this.dialog_marks_sem2 = false;      
        }
      } else {
        this.showSnackbar("#b71c1c", "Save failed");
      }
    })
    .catch(err => {
      console.error(err);
      this.showSnackbar("#b71c1c", "Error saving remarks");
    })
    .finally(() => {
      this.saving = false;
    });
},
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                org: this.org,
            };
            axios
                .post("/ZealExamination/getStudentReportCard", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.dob = res.data.dob;
                        this.roll_no = res.data.roll_no;
                        this.mobile_no = res.data.mobile_no;
                        this.telephone_no = res.data.telephone_no;
                        this.father_contact_number = res.data.father_contact_number;
                        this.address = res.data.address;
                        this.mother_name = res.data.mother_name;
                        this.photo = res.data.photo;
                        this.reg_no = res.data.reg_no;
                        this.gr_no = res.data.gr_no;
                        this.father_full_name = res.data.father_full_name;
                        this.mother_occupation = res.data.mother_occupation;
                        this.father_occupation = res.data.father_occupation;
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        this.semester = res.data.semester;
                        // this.default_value = res.data.default_value;
                        this.remarkable_progress_defaults = res.data.remarkable_progress_defaults || [];
                        this.student_hobbies_defaults = res.data.student_hobbies_defaults || [];
                        this.expected_improvement_defaults = res.data.expected_improvement_defaults || [];
                        this.org_basic_data = res.data.org_basic_data;
                        this.mother_contact = res.data.mother_contact;
                        this.father_contact = res.data.father_contact;
                        this.house = res.data.house;
                        this.adhar_no = res.data.adhar_no;
                        this.email = res.data.email;
                        this.age = res.data.age;
                        this.all_data = res.data;
                        this.lms_id = this.leraner_marksheet.lms_id;
                        this.lms_id_sem2 = this.leraner_marksheet.lms_id_sem2;
                        this.schlname = this.org_basic_data.school_name;
                        this.sem1_attendance = res.data.sem1_attendance;
                        this.sem2_attendance = res.data.sem2_attendance;
                        this.user_bmi_list_sem1 = res.data.user_bmi_list_sem1;
                        this.user_bmi_list_sem2 = res.data.user_bmi_list_sem2;
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.registration_no = localStorage.getItem("setreg_no");
        this.org_id = localStorage.getItem("EPS-tenant");
        this.onload();
    },
};
</script>
<style scoped>
#table1 td {
    padding: 0px;
    padding-left: 5px;
}
.round{
    display: inline-block;
      padding: 10px 20px;
      border: 2px solid black;
      border-radius: 20px;
      font-size: 20px;
      font-weight: bold;
      box-shadow: 4px 4px 0px #000;
}

.ribbon {
    --s: 70px;
    --d: 20px;
    --c: 20px;
    padding: 0 calc(var(--s) + var(--d)) var(--d);
    background: conic-gradient(at left var(--s) bottom var(--d), #0000 25%, #0008 0 37.5%, #0004 0) 0 /50% no-repeat, conic-gradient(at right var(--s) bottom var(--d), #0004 62.5%, #0008 0 75%, #0000 0) 100%/50% no-repeat;
    clip-path: polygon(0 var(--d),
            var(--s) var(--d),
            var(--s) 0,
            calc(100% - var(--s)) 0,
            calc(100% - var(--s)) var(--d),
            100% var(--d),
            calc(100% - var(--c)) calc(50% + var(--d) / 2),
            100% 100%,
            calc(100% - var(--s) - var(--d)) 100%,
            calc(100% - var(--s) - var(--d)) calc(100% - var(--d)),
            calc(var(--s) + var(--d)) calc(100% - var(--d)),
            calc(var(--s) + var(--d)) 100%,
            0 100%,
            var(--c) calc(50% + var(--d) / 2));
    background-color: #cc333f;
}

.school-name {
    display: inline-block;
    position: relative;
    padding: 10px;
    background-color: #005ab3;
    border: 2px solid #000;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
    font-weight: bold;
    color: #000;
}

.school-name::before,
.school-name::after {
    content: "\00a0";
    position: absolute;
    top: 70%;
    transform: translateY(-50%);
    font-weight: bold;
    color: #000;
    background-color: #005ab3;
    padding: 5px 10px;
    border: 2px solid #000;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
}

.school-name::before {
    left: -28px;
}

.school-name::after {
    right: -28px;
}

.styled-div2 {
    /* border: 3px solid goldenrod;
    border-radius: 20px; */
    margin: 10px;
    font-size: small;
    background-color: #e8daef !important;
}

.styled-div2 tr {
    height: 10px !important;
}

.styled-div2 td,
tr {
    border: none !important;
    line-height: 28px;
}

.styled-div {
    border: 3px solid goldenrod;
    border-radius: 20px;
    margin: 10px;
    font-size: small;
}

.styled-div tr {
    height: 10px !important;
}

.styled-div td,
tr {
    border: none !important;
    padding: 0px 5px;
}

#table1 th,
td {
    padding: 10px;
}

#table_term td {
    padding: 10px;
}

thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

@media (min-width: 320px) {
    td,
    th {
        display: table-cell !important;
        border: 1px solid black !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    font-size: small;
}

@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    th {
        white-space: nowrap;
    }

    @page {
        size: A4 landscape !important;
        font-family: "Times New Roman", Times, serif;
        margin: 0 !important;
    }

    .styled-div {
        padding: 0px !important;
    }

    .pagebreak {
        page-break-before: always;
        line-height: -50px !important;
    }
}
</style>
